import _ from 'lodash';
import angular from 'angular';
import BaseComponent from '../../../../base/component';
import { Inject } from '../../../../base/decorators';
import UtilsService from '../../../../../services/utilsService';

export class EmployerRepLinkedinActivateComponent extends BaseComponent {
    @Inject('$stateParams') $stateParams;

    @Inject('$localStorage') $localStorage;

    @Inject('$cookies') $cookies;

    @Inject('AuthService') authService;

    @Inject('EmployerRepService') employerRepService;

    @Inject('NotificationService') notificationService;

    async activateEmployerRep({
        employerRepId, actionType, positionId, email, employerId,
    }) {
        try {
            const { result: data } = await this.employerRepService.activateLinkedinEmployerRep(employerRepId, {
                email,
                positionId,
                actionType,
                employerId,
            }) || {};

            if (data) {
                if (data.validationErrors) {
                    const { messages = [] } = data.validationErrors.validationMessages;
                    const prefix = actionType === 'FEEDBACK' ? 'FEEDBACK_REQUEST' : 'SEND_TO_EMPLOYER';
                    messages.map((item) => {
                        if (item.errType === 'inactiveEmployerRep') {
                            const details = `${prefix}_EMAIL_ALERT_MESSAGE_INACTIVE`;
                            this.notificationService.error(`${item.email} ${this.$filter('translate')(details)}`);
                        }
                        if (item.errType === 'inactiveRecruiter') {
                            const details = `${prefix}_EMAIL_ALERT_MESSAGE_INACTIVE`;
                            this.notificationService.error(`${item.email} ${this.$filter('translate')(details)}`);
                        }
                        if (item.errType === 'notBelongsToEmployer') {
                            const details = `${prefix}_EMAIL_ALERT_MESSAGE_OTHER_EMPLOYER`;
                            this.notificationService.error(`${item.email} ${this.$filter('translate')(details)}`);
                        }
                    });

                    return this.$state.go('employerRep.signUp.password', { employerRepId });
                }
                ({ employerRepId } = data);
                _.set(this, '$localStorage.employerRepReturnUrlParams.targetEmployerRepId', employerRepId);
                return this.$state.go('employerRep.signUp.activate', { employerRepId });
            }
        } catch (error) {
            this.logger.error(error);
            this.authService.logout();
        }
    }

    componentDataWillSetup() {
    }

    async setupComponentData() {
        const { employerRepId } = this.$stateParams;
        const { positionId, actionType, employerId } = _.get(this, '$localStorage.employerRepReturnUrlParams');

        if (!employerRepId || !positionId || !actionType || !employerId) {
            this.$state.go('logout');
        }

        UtilsService.cookiesOverride(this.$cookies);

        const user = UtilsService.parseJSON(this.$cookies.get('userData'));
        const email = user?.email;

        return this.activateEmployerRep({
            employerRepId,
            actionType,
            positionId,
            email,
            employerId,
        });
    }
}

export const EmployerRepLinkedinActivateComponentConfiguration = {
    template: '<tft-spinner></tft-spinner>',
    controller: EmployerRepLinkedinActivateComponent,
    controllerAs: 'employerRepLinkedinActivateComponentCtrl',
};

angular.module('TALENYA-FE')
    .component('employerRepLinkedinActivateComponent', EmployerRepLinkedinActivateComponentConfiguration);
